export default __webpack_public_path__ + "static/GPE-d75de70e92e519f2fcddcc42899b1fe7.jpg";